<div [formGroup]="form">

    <div class="row">
        <div class="col-md-12">

            <div class="row">
                <!--Control documental-->
                <div class="col-md-6">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedControlDocumental = !isCollapsedControlDocumental" [attr.aria-expanded]="!isCollapsedControlDocumental" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Control documental
                                <i *ngIf="isCollapsedControlDocumental" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedControlDocumental" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>

                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedControlDocumental" [ngbCollapse]="isCollapsedControlDocumental">
                                <div class="row">

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="ControlDocumentalCheck">Realizado</label>
                                        <div *ngIf="tracesParteII?.ControlDocumentalCheck === true" class="icon-satisfactory-rechazos-traces">
                                            <img src="../../../../../../assets/images/Rechazos_TRACES/Satisfactorio.png" />
                                        </div>
                                        <div *ngIf="(controlDocumentalCheckFalse === true || tracesParteII?.ControlDocumentalCheck === false)" class="icon-satisfactory-rechazos-traces">
                                            <img src="../../../../../../assets/images/Rechazos_TRACES/NO_Satisfactorio.png" />
                                        </div>

                                    </div>

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="ControlDocumentalResult">Resultado</label>
                                        <input formControlName="ControlDocumentalResult" name="ControlDocumentalResult" title="" class="form-control" id="ControlDocumentalResult" type="text" value="" [ngClass]="displayFieldCss('ControlDocumentalResult')" readonly>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <!--Control identidad-->
                <div class="col-md-6">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedControlIdentidad = !isCollapsedControlIdentidad" [attr.aria-expanded]="!isCollapsedControlIdentidad" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Control de identidad
                                <i *ngIf="isCollapsedControlIdentidad" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedControlIdentidad" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>

                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedControlDocumental" [ngbCollapse]="isCollapsedControlIdentidad">
                                <div class="row">

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="ControlIdentidadCheck">Realizado</label>
                                        <div *ngIf="tracesParteII?.ControlIdentidadCheck === true" class="icon-satisfactory-rechazos-traces">
                                            <img src="../../../../../../assets/images/Rechazos_TRACES/Satisfactorio.png" />
                                        </div>
                                        <div *ngIf="controlIdentidadCheckFalse === true || tracesParteII?.ControlIdentidadCheck === false" class="icon-satisfactory-rechazos-traces">
                                            <img src="../../../../../../assets/images/Rechazos_TRACES/NO_Satisfactorio.png" />
                                        </div>

                                    </div>

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="ControlIdentidadResult">Resultado</label>
                                        <input formControlName="ControlIdentidadResult" name="ControlIdentidadResult" title="" class="form-control" id="ControlIdentidadResult" type="text" value="" [ngClass]="displayFieldCss('ControlIdentidadResult')" readonly>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <!--Control físico-->
                <div class="col-md-6">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedControlFisico = !isCollapsedControlFisico" [attr.aria-expanded]="!isCollapsedControlFisico" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Control físico
                                <i *ngIf="isCollapsedControlFisico" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedControlFisico" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>

                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedControlDocumental" [ngbCollapse]="isCollapsedControlFisico">
                                <div class="row">

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="ControlFisicoCheck">Realizado</label>
                                        <div *ngIf="tracesParteII?.ControlFisicoCheck === true" class="icon-satisfactory-rechazos-traces">
                                            <img src="../../../../../../assets/images/Rechazos_TRACES/Satisfactorio.png" />
                                        </div>
                                        <div *ngIf="controlFisicoCheckFalse === true || tracesParteII?.ControlFisicoCheck === false" class="icon-satisfactory-rechazos-traces">
                                            <img src="../../../../../../assets/images/Rechazos_TRACES/NO_Satisfactorio.png" />
                                        </div>

                                    </div>

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="ControlFisicoResult">Resultado</label>
                                        <input formControlName="ControlFisicoResult" name="ControlFisicoResult" title="" class="form-control" id="ControlFisicoResult" type="text" value="" [ngClass]="displayFieldCss('ControlFisicoResult')" readonly>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <!--Control COI-->
                <div class="col-md-6">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedControlCOI = !isCollapsedControlCOI" [attr.aria-expanded]="!isCollapsedControlCOI" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Control COI
                                <i *ngIf="isCollapsedControlCOI" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedControlCOI" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>

                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedControlDocumental" [ngbCollapse]="isCollapsedControlCOI">
                                <div class="row">

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="ControlCOICheck">Realizado</label>
                                        <div *ngIf="tracesParteII?.ControlCOICheck === true" class="icon-satisfactory-rechazos-traces">
                                            <img src="../../../../../../assets/images/Rechazos_TRACES/Satisfactorio.png" />
                                        </div>
                                        <div *ngIf="controlCOICheckFalse === true || tracesParteII?.ControlCOICheck === false" class="icon-satisfactory-rechazos-traces">
                                            <img src="../../../../../../assets/images/Rechazos_TRACES/NO_Satisfactorio.png" />
                                        </div>

                                    </div>

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="ControlCOIResult">Resultado</label>
                                        <input formControlName="ControlCOIResult" name="ControlCOIResult" title="" class="form-control" id="ControlCOIResult" type="text" value="" [ngClass]="displayFieldCss('ControlCOIResult')" readonly>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="row">
                <!--Inspector oficial-->
                <div class="col-md-12">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedInspectorOficial = !isCollapsedInspectorOficial" [attr.aria-expanded]="!isCollapsedInspectorOficial" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Inspector oficial
                                <i *ngIf="isCollapsedInspectorOficial" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedInspectorOficial" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>

                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedInspectorOficial" [ngbCollapse]="isCollapsedInspectorOficial">
                                <div class="row">

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="NombreInspector">Nombre</label>
                                        <input formControlName="NombreInspector" name="NombreInspector" title="" class="form-control" id="NombreInspector" type="text" value="" [ngClass]="displayFieldCss('NombreInspector')" readonly>
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="PaisInspector">País</label>
                                        <input formControlName="PaisInspector" name="PaisInspector" title="" class="form-control" id="PaisInspector" type="text" value="" [ngClass]="displayFieldCss('PaisInspector')" readonly>
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="FechaInspeccion">Fecha</label>
                                        <input formControlName="FechaInspeccion" name="FechaInspeccion" title="" class="form-control" id="FechaInspeccion" type="text" value="" [ngClass]="displayFieldCss('FechaInspeccion')" readonly>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="row">
                <!--Conclusión-->
                <div class="col-md-3">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedConclusion = !isCollapsedConclusion" [attr.aria-expanded]="!isCollapsedConclusion" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Conclusión
                                <i *ngIf="isCollapsedConclusion" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedConclusion" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>

                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedConclusion" [ngbCollapse]="isCollapsedConclusion">
                                <div class="row">

                                    <div class="form-group col-md-12">
                                        <label class="col-form-label" for="Conclusion">Conclusión</label>
                                        <input formControlName="Conclusion" name="Conclusion" title="" class="form-control" id="Conclusion" type="text" value="" [ngClass]="displayFieldCss('Conclusion')" readonly>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <!--PCF-->
                <div class="col-md-9">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedPCF = !isCollapsedPCF" [attr.aria-expanded]="!isCollapsedPCF" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Código de Unidad de Control
                                <i *ngIf="isCollapsedPCF" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedPCF" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>

                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedPCF" [ngbCollapse]="isCollapsedPCF">
                                <div class="row">

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="NombrePIF">Nombre</label>
                                        <input formControlName="NombrePIF" name="NombrePIF" title="" class="form-control" id="NombrePIF" type="text" value="" [ngClass]="displayFieldCss('NombrePIF')" readonly>
                                    </div>

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="PaisPIF">País</label>
                                        <input formControlName="PaisPIF" name="PaisPIF" title="" class="form-control" id="PaisPIF" type="text" value="" [ngClass]="displayFieldCss('PaisPIF')" readonly>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--Medidas-->
            <div class="row">
                <div class="col-md-12">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedMedidas = !isCollapsedMedidas" [attr.aria-expanded]="!isCollapsedMedidas" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Medidas
                                <!--<i *ngIf="isCollapsedMedidas" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedMedidas" class="fa fa-caret-up float-right"></i>-->
                            </div>
                        </a>

                        <div class="card-body-rechazos-traces">

                            <p-table #tableSearch autoLayout="true"
                                     [value]="tracesParteII?.MedidasList"
                                     [columns]="colsMedidas" sortField="Descripcion" sortOrder="1"
                                     styleClass="table table-responsive-sm table-striped table-sm"
                                     [ngClass]="displayGridHidden(tracesParteII?.MedidasList)">

                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field" class="w-50">
                                            {{col.header}}
                                            <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                        </th>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                    <tr>
                                        <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                            <span>{{rowData[col.field]}}</span>
                                        </td>
                                    </tr>
                                </ng-template>

                            </p-table>

                            <div *ngIf="numeroMedidas === 0" class="empty-grid">
                                {{ isRechazo ? 'No hay medidas asociadas al rechazo' : 'No hay medidas asociadas al traslado' }}
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            <!--Motivos-->
            <div class="row">
                <div class="col-md-12">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedMotivos = !isCollapsedMotivos" [attr.aria-expanded]="!isCollapsedMotivos" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Motivos
                                <!--<i *ngIf="isCollapsedMotivos" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedMotivos" class="fa fa-caret-up float-right"></i>-->
                            </div>
                        </a>

                        <div class="card-body-rechazos-traces">

                            <p-table #tableSearch autoLayout="true"
                                     [value]="tracesParteII?.MotivosList"
                                     [columns]="colsMotivos" sortField="Descripcion" sortOrder="1"
                                     styleClass="table table-responsive-sm table-striped table-sm"
                                     [ngClass]="displayGridHidden(tracesParteII?.MotivosList)">

                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field" class="w-50">
                                            {{col.header}}
                                            <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                        </th>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                    <tr>
                                        <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                            <span>{{rowData[col.field]}}</span>
                                        </td>
                                    </tr>
                                </ng-template>

                            </p-table>

                            <div *ngIf="numeroMotivos === 0" class="empty-grid">
                                {{ isRechazo ? 'NNo hay motivos asociados al rechazo' : 'No hay motivos asociados al traslado' }}
                            </div>

                        </div>

                    </div>
                </div>
            </div>

        </div>
    </div>

</div>
